var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-data-view-abstract-view.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { DateTime } from "luxon";
import "./data-view-options.js";
var XDataViewAbstractView = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.fullOptions = new RXController(this, null);
    this.data = [];
    this.loading = true;
  }
  get options() {
    if (!this.fullOptions.value)
      throw new Error("asking for options too early");
    return this.fullOptions.value;
  }
  resolveID(entityInstance) {
    return entityInstance.constructor.resolveID(entityInstance);
  }
  virtualizationWrapper(entityInstance, index, displayContents = true) {
    const div = document.createElement("div");
    if (displayContents)
      div.style.setProperty("display", "contents");
    div.setAttribute("row", "");
    return div;
  }
  handleArray(fieldValue) {
    let result = null;
    for (const val of fieldValue) {
      if (result === null)
        result = this.fallbackRenderItem(val);
      else
        result = html` ${result} <x-text> &#183; </x-text> ${this.fallbackRenderItem(val)} `;
    }
    return html` <x-flex horizontal space="xs" wrap> ${result} </x-flex> `;
  }
  getFieldType(fieldValue) {
    if (fieldValue === void 0 || fieldValue === null)
      return "";
    switch (typeof fieldValue) {
      case "object":
        if (DateTime.isDateTime(fieldValue))
          return "DateTime";
        return fieldValue.constructor.name;
      default:
        return typeof fieldValue;
    }
  }
  fallbackRenderItem(fieldValue) {
    if (Array.isArray(fieldValue))
      return this.handleArray(fieldValue);
    const fieldType = this.getFieldType(fieldValue);
    let renderable = this.options.defaultFieldMapping[fieldType]?.(fieldValue) ?? fieldValue;
    if (!renderable["_$litType$"])
      renderable = html` <x-text ellipsis .value=${renderable}></x-text> `;
    return renderable;
  }
};
__decorateClass([
  property({ attribute: false })
], XDataViewAbstractView.prototype, "fullOptions", 2);
__decorateClass([
  property({ attribute: false })
], XDataViewAbstractView.prototype, "data", 2);
__decorateClass([
  property({ attribute: true })
], XDataViewAbstractView.prototype, "loading", 2);
XDataViewAbstractView = __decorateClass([
  customElement("x-data-view-abstract-view")
], XDataViewAbstractView);
export {
  XDataViewAbstractView
};
